import {
  IconClipboard,
  IconTrophy,
  IconFilter,
  IconPlus,
  IconHourglass,
  IconMoneybag,
  IconBook,
  IconSchool,
  IconCircleCheckFilled,
  IconCircleXFilled,
  IconLayoutGrid,
  IconUsersGroup,
  IconSearch,
  IconFile,
  IconBrandYoutubeFilled,
  IconPhoto,
  IconList,
  IconPaperclip,
  IconSend,
  IconClock,
  IconTrendingUp,
  IconTrendingDown,
  IconNotification,
  IconEye,
  IconEdit,
  IconRowRemove,
  IconArrowRight,
  IconTableRow,
  IconPresentation,
  IconImageInPicture,
  IconVideoPlus,
  IconMenu2,
  IconChevronDown,
  IconTrash,
  IconToggleLeftFilled,
  IconToggleRightFilled,
  IconCheck,
  IconArrowLeft,
  IconUserCancel,
  IconMail,
  IconPhone,
  IconMoodSmile,
  IconSettings,
  IconReplaceFilled,
  IconLocationPin,
  IconChartBar,
  IconCalendar,
  IconNetwork,
  IconClick,
  IconBasket,
  IconDeviceDesktop,
  IconTextSize,
  IconClockQuestion,
  IconBookOff,
  IconX,
  IconWand,
  IconSandbox,
  IconArrowsSort,
  IconColumns,
  IconChevronRight,
  IconChevronLeft,
  IconLinkOff,
  IconExternalLink,
  IconDotsVertical,
  IconBuilding,
  IconBriefcase,
  IconChevronUp,
  IconUpload,
  IconPigMoney,
  IconRefresh,
  IconBooks,
  IconUserPlus,
  IconDoorExit,
  IconStar,
  IconBrain,
  IconMicroscope,
  IconTimeline,
  IconHelpCircleFilled,
  IconEyeOff,
  IconReportOff,
  IconMinus,
  IconDeviceUsb,
  IconPasswordMobilePhone,
  IconKeyFilled,
  IconUsb,
  IconKey,
  IconDeviceMobileMessage,
  IconFiles,
  IconBadge,
  IconCertificate,
  IconHourglassFilled,
  IconUserUp,
  IconUserStar,
  IconThumbUp,
  IconMessage,
  IconShare,
  IconBrandYoutube,
  IconWindowMinimize,
  IconWindowMaximize,
  IconLinkPlus,
  IconHome,
  IconWorld,
  IconPhotoOff,
  IconNumber1,
  IconNumber2,
  IconNumber3,
  IconArrowsShuffle,
  IconNfc,
  IconPlayerPlay,
  IconMusic,
  IconCreditCard,
  IconCircleFilled,
  IconCircleCheck,
  IconCircleX,
  IconWaveSine,
  IconTextRecognition,
  IconHandClick,
  IconCopy,
  IconEditOff,
  IconSpeakerphone,
  IconRobot,
  IconActivity,
  IconSquares,
  IconUserSearch,
  IconUserQuestion,
  IconChecklist,
  IconBrandGoogle,
  IconPresentationFilled,
  IconBrandGoogleFilled,
  IconMenu4,
  IconTargetArrow,
  IconNote,
  IconNotes,
  IconHelpCircle,
  IconVolumeOff,
  IconPlayerPause,
  IconRepeat,
  IconRepeatOff,
  IconBulb,
  IconGlobe,
  IconShield,
  IconCode,
  IconCalculator,
  IconUserCheck,
  IconPalette,
  IconResize,
  IconBrandLinkedin,
  IconBrandLinkedinFilled,
  IconTarget,
  IconBuildingBank,
} from "@tabler/icons-react";

export function icon(name, SIZE = 17, color) {
  switch (name) {
  case "trend-up":
    return <IconChevronUp size={SIZE} data-testid="trend-up" color={color} />;

  case "trend-down":
    return <IconChevronDown size={SIZE} data-testid="trend-down" color={color} />;

  case "trend-flat":
    return <IconMinus size={SIZE} data-testid="trend-flat" color={color} />;

    case "ai-suggestion":
    return <IconRobot size={SIZE} data-testid={"ai"} color={color} />;
        case "demo":
      return (
        <IconPresentationFilled
          size={SIZE}
          data-testid={"demo"}
          color={color}
        />
      );

      case "info":
    return (
      <IconHelpCircle
        size={SIZE}
        data-testid={"info"}
        color={color}
      />
    );
  case "opened_embed":
    return <IconEye size={SIZE} data-testid={"eye"} color={color} />;

  case "started_embed":
    return <IconHourglass size={SIZE} data-testid={"bezig"} color={color} />;

  case "finished_assessment":
    return <IconTrophy size={SIZE} data-testid={"afgerond"} color={color} />;
    case "follow-up":
      return (
        <IconRefresh
          size={SIZE}
          data-testid={"follow-up"}
          color={color}
        />
      );

    case "lead-qualification":
      return (
        <IconChecklist
          size={SIZE}
          data-testid={"lead-qualification"}
          color={color}
        />
      );
  case "note":
    return (
      <IconNotes
        size={SIZE}
        data-testid={"note"}
        color={color}
      />
    );
    case "marketing":
      return (
        <IconSpeakerphone
          size={SIZE}
          data-testid={"marketing"}
          color={color}
        />
      );

    case "google":
      return (
        <IconBrandGoogleFilled
          size={SIZE}
          data-testid={"google"}
          color={color}
        />
      );
    case "background":
      return (
        <IconWaveSine size={SIZE} data-testid={"background"} color={color} />
      );
    case "audio":
      return <IconMusic size={SIZE} data-testid={"audio"} color={color} />;
    case "video":
      return <IconVideoPlus size={SIZE} data-testid={"video"} color={color} />;
    case "youtube":
      return (
        <IconBrandYoutube size={SIZE} data-testid={"youtube"} color={color} />
      );
    case "text_transcription":
      return (
        <IconTextRecognition
          size={SIZE}
          data-testid={"text_transcription"}
          color={color}
        />
      );
    case "activity":
      return (
        <IconActivity size={SIZE} data-testid={"activity"} color={color} />
      );

    case "minimize":
      return (
        <IconWindowMinimize
          size={SIZE}
          data-testid={"minimize"}
          color={color}
        />
      );
    case "maximize":
      return (
        <IconWindowMaximize
          size={SIZE}
          data-testid={"maximize"}
          color={color}
        />
      );
    case "play":
      return <IconPlayerPlay size={SIZE} data-testid={"play"} color={color} />;
    case "intern":
      return <IconHome size={SIZE} data-testid={"intern"} color={color} />;
    case "extern":
      return <IconWorld size={SIZE} data-testid={"extern"} color={color} />;

    case "contactless":
      return <IconNfc size={SIZE} data-testid={"contactless"} color={color} />;

    case "minus":
      return <IconMinus size={SIZE} data-testid={"minus"} color={color} />;
    case "documents":
      return <IconFiles size={SIZE} data-testid={"documents"} color={color} />;
    case "badge":
      return <IconBadge size={SIZE} data-testid={"badge"} color={color} />;
    case "certificate":
      return (
        <IconCertificate
          size={SIZE}
          data-testid={"certificate"}
          color={color}
        />
      );
    case "error":
      return (
        <IconCircleXFilled size={SIZE} color={color} data-testid={"error"} />
      );
    case "hourglass":
      return (
        <IconHourglassFilled
          size={SIZE}
          color={color}
          data-testid={"hourglass"}
        />
      );
    case "hourglass-2":
      return (
        <IconHourglass size={SIZE} color={color} data-testid={"hourglass-2"} />
      );
    case "lead-start":
      return (
        <IconNumber1 size={SIZE} color={color} data-testid={"lead-start"} />
      );
    case "not-connected":
      return (
        <IconLinkOff size={SIZE} color={color} data-testid={"not-connected"} />
      );
    case "lead-middle":
      return (
        <IconNumber2 size={SIZE} color={color} data-testid={"lead-middle"} />
      );
    case "lead-end":
      return <IconNumber3 size={SIZE} color={color} data-testid={"lead-end"} />;
    case "lead-abtest":
      return (
        <IconArrowsShuffle
          size={SIZE}
          color={color}
          data-testid={"lead-abtest"}
        />
      );

    case "refresh":
      return <IconRefresh size={SIZE} data-testid={"refresh"} color={color} />;
    case "upload":
      return <IconUpload size={SIZE} data-testid={"upload"} color={color} />;
    case "no-reports":
      return (
        <IconReportOff size={SIZE} data-testid={"no-reports"} color={color} />
      );
    case "project":
      return <IconTimeline size={SIZE} data-testid={"project"} color={color} />;

    case "star":
      return <IconStar size={SIZE} data-testid={"star"} color={color} />;
    case "brain":
      return <IconBrain size={SIZE} data-testid={"brain"} color={color} />;
    case "research":
      return (
        <IconMicroscope size={SIZE} data-testid={"research"} color={color} />
      );
    case "company":
      return <IconBuilding size={SIZE} data-testid={"company"} color={color} />;

    // Dashboard Modules
    case "simple_business":
      return (
        <IconBuilding
          size={SIZE}
          data-testid={"simple_business"}
          color={color}
        />
      );
    case "simple_earnings":
      return <IconBasket size={SIZE} data-testid={"sold"} color={color} />;
    case "simple_hours":
      return <IconClock size={SIZE} data-testid={"simple_hours"} />;
    case "simple_left_modules":
      return (
        <IconBookOff
          size={SIZE}
          data-testid={"simple_left_modules"}
          color={color}
        />
      );
    case "simple_users":
      return <IconUsersGroup color={color} data-testid={"simple_users"} size={SIZE} />;
    case "simple_active_courses":
      return (
        <IconPresentation
          size={SIZE}
          data-testid={"simple_courses"}
          color={color}
        />
      );
    case "simple_modules":
      return (
        <IconBooks size={SIZE} data-testid={"simple_modules"} color={color} />
      );
    case "simple_leads":
      return <IconUserPlus size={SIZE} data-testid={"leads"} color={color} />;
    case "lead_search":
      return <IconUserSearch size={SIZE} data-testid={"leads"} color={color} />;
    case "lead_question":
      return <IconUserQuestion size={SIZE} data-testid={"leads"} color={color} />;

    case "simple_avg_course":
      return (
        <IconChartBar
          size={SIZE}
          data-testid={"simple_avg_course"}
          color={color}
        />
      );
    case "simple_modules_started":
      return (
        <IconBooks
          size={SIZE}
          data-testid={"simple_modules_started"}
          color={color}
        />
      );
    case "simple_popular":
      return (
        <IconStar size={SIZE} data-testid={"simple_popular"} color={color} />
      );
    case "simple_started":
      return (
        <IconHourglass
          size={SIZE}
          data-testid={"simple_started"}
          color={color}
        />
      );

    case "dots-vertical":
      return (
        <IconDotsVertical
          size={SIZE}
          data-testid={"dots-vertical"}
          color={color}
        />
      );
    case "alphabet":
      return (
        <IconTextSize size={SIZE} data-testid={"alphabet"} color={color} />
      );
    case "columns":
      return <IconColumns size={SIZE} data-testid={"columns"} color={color} />;
    case "clipboard":
      return (
        <IconClipboard size={SIZE} data-testid={"clipboard"} color={color} />
      );
    case "book-off":
      return <IconBookOff size={SIZE} data-testid={"book off"} color={color} />;
    case "sorter":
      return (
        <IconArrowsSort data-testid={"sorter"} size={SIZE} color={color} />
      );
      case "menu-open":
      return (
        <IconMenu4 size={SIZE} data-testid={"menu-open"} color={color} />
      );

    case "sidebar-open":
      return (
        <IconMenu2 size={SIZE} data-testid={"sidebar-open"} color={color} />
      );

    case "sidebar-close":
      return (
        <IconChevronLeft
          size={SIZE}
          data-testid={"sidebar-close"}
          color={color}
        />
      );
    case "money":
      return <IconMoneybag data-testid={"money"} size={SIZE} color={color} />;
    case "file":
      return <IconFile data-testid={"file"} size={SIZE} color={color} />;
    case "mail":
      return <IconMail data-testid={"mail"} size={SIZE} color={color} />;
    case "status":
      return (
        <IconCircleFilled size={SIZE} color={color} data-testid={"status"} />
      );
    case "text-size":
      return (
        <IconTextSize data-testid={"text-size"} size={SIZE} color={color} />
      );
    case "phone":
      return <IconPhone data-testid={"phone"} size={SIZE} color={color} />;
    case "paperclip":
      return (
        <IconPaperclip data-testid={"paperclip"} size={SIZE} color={color} />
      );
    case "photo":
      return <IconPhoto data-testid={"photo"} size={SIZE} color={color} />;
    case "send":
      return <IconSend data-testid={"send"} size={SIZE} color={color} />;
    case "book":
      return <IconBook data-testid={"book"} size={SIZE} color={color} />;
    case "users":
      return <IconUsersGroup data-testid={"users"} size={SIZE} color={color} />;
    case "afgerond":
      return <IconTrophy data-testid={"afgerond"} size={SIZE} color={color} />;
    case "campagne":
      return <IconSpeakerphone data-testid={"campagne"} size={SIZE} color={color} />;
    case "bezig":
      return <IconHourglass data-testid={"bezig"} size={SIZE} color={color} />;
    case "clock":
      return <IconClock data-testid={"clock"} size={SIZE} color={color} />;
    case "increase":
      return <IconTrendingUp data-testid={"updown"} color={"#31B648"} />;
    case "decrease":
      return <IconTrendingDown data-testid={"updown"} color={color} />;
    case "notification":
      return <IconNotification data-testid={"notication"} color={color} />;
    case "see":
      return <IconEye data-testid={"eye"} size={SIZE} color={color} />;

    case "inactief":
      return <IconEyeOff size={SIZE} color={color} data-testid={"inactief"} />;

    case "squares":
      return <IconSquares size={SIZE} color={color} data-testid={"squares"} />;

    case "bijwerken":
      return <IconEdit data-testid={"edit"} size={SIZE} color={color} />;
    case "bijwerken-off":
      return <IconEditOff data-testid={"edit"} size={SIZE} color={color} />;
    case "edit":
      return <IconEdit data-testid={"edit"} size={SIZE} color={color} />;
    case "plus":
      return <IconPlus size={SIZE} data-testid={"plus"} color={color} />;
    case "published":
      return (
        <IconSend data-testid={"gepubliceerd"} size={SIZE} color={color} />
      );
    case "activity":
      return (
        <IconActivity size={SIZE} data-testid={"activity"} color={color} />
      );
    case "gepubliceerd":
      return (
        <IconSend data-testid={"gepubliceerd"} size={SIZE} color={color} />
      );
    case "delete":
      return <IconRowRemove color={"#F83B3B"} data-testid={"delete"} />;
    case "arrow-right":
      return (
        <IconArrowRight size={SIZE} data-testid={"delete"} color={color} />
      );
    case "arrow-left":
      return <IconArrowLeft size={SIZE} data-testid={"delete"} color={color} />;
    case "mood-smile":
      return <IconMoodSmile data-testid={"mood smike"} />;
    case "rows":
      return <IconTableRow data-testid={"delete"} />;
    case "folder":
      return <IconPresentation data-testid={"delete"} />;
    case "filter":
      return <IconFilter data-testid={"delete"} size={SIZE} color={color} />;
    case "add-image":
      return <IconImageInPicture data-testid={"delete"} />;
    case "image":
      return <IconPhotoOff size={SIZE} color={color} />;
    case "add-video":
      return <IconVideoPlus data-testid={"delete"} />;
    case "menu":
      return <IconMenu2 data-testid={"delete"} />;
    case "arrow-down":
      return (
        <IconChevronDown data-testid={"delete"} size={SIZE} color={color} />
      );
    case "chevron-right":
      return <IconChevronRight size={SIZE} data-testid={"chevron right"} />;
    case "chevron-left":
      return <IconChevronLeft size={SIZE} data-testid={"chevron left"} />;
    case "chevron-up":
      return <IconChevronUp size={SIZE} data-testid={"chevron up"} />;
    case "chevron-down":
      return <IconChevronDown size={SIZE} data-testid={"chevron down"} />;
    case "card":
      return <IconCreditCard size={SIZE} color={color} data-testid="card" />;
    case "generate-video":
      return (
        <IconVideoPlus
          size={SIZE}
          color={color}
          data-testid={"generate-video"}
        />
      );

    case "generate-audio":
      return (
        <IconMusic size={SIZE} color={color} data-testid={"generate-audio"} />
      );
    case "trash":
      return (
        <IconTrash
          size={SIZE || "17"}
          style={{ margin: "0.3rem" }}
          color={"#F83B3B"}
          data-testid={"delete"}
        />
      );
    case "on":
      return (
        <IconToggleLeftFilled
          size={"25"}
          style={{ margin: "0.3rem" }}
          color={"#F83B3B"}
          data-testid={"delete"}
        />
      );
    case "off":
      return (
        <IconToggleRightFilled
          size={"25"}
          style={{ margin: "0.3rem" }}
          color={"#2532EB"}
          data-testid={"delete"}
        />
      );
    case "check":
      return (
        <IconCheck
          size={SIZE || "25"}
          style={{ margin: "0.3rem", marginBottom: "-2px" }}
          color={color}
          data-testid={"delete"}
        />
      );
    case "checkbox-check":
      return <IconCheck size={SIZE} data-testid={"check"} />;
    case "x":
      return <IconX size={SIZE} data-testid={"xmark"} color={color} />;
    case "check-small":
      return (
        <IconCheck
          size={"20"}
          style={{ marginRight: "0.3rem" }}
          color={"#2532EB"}
          data-testid={"check"}
        />
      );
    case "cross":
      return (
        <IconUserCancel
          size={"25"}
          style={{ margin: "0.3rem" }}
          color={"#2532EB"}
          data-testid={"delete"}
        />
      );
    case "setting":
      return (
        <IconSettings
          size={SIZE}
          style={{ margin: "0.3rem" }}
          color={color}
          data-testid={"delete"}
        />
      );
    case "settings":
      return <IconSettings size={SIZE} color={color} data-testid={"delete"} />;
    case "add":
      return (
        <IconReplaceFilled
          size={"25"}
          style={{ margin: "0.3rem" }}
          color={"#2532EB"}
          data-testid={"delete"}
        />
      );
    case "location":
      return (
        <IconLocationPin size={"17"} data-testid={"delete"} color={color} />
      );
    case "location":
      return (
        <IconLocationPin size={"17"} data-testid={"delete"} color={color} />
      );
    case "chart":
      return <IconChartBar size={"17"} data-testid={"delete"} color={color} />;
    case "calendar":
      return <IconCalendar size={"17"} data-testid={"delete"} color={color} />;
    case "network":
      return <IconNetwork size={"25"} data-testid={"delete"} color={color} />;
    case "eye":
      return <IconEye size={SIZE} data-testid={"delete"} color={color} />;
    case "click":
      return <IconClick size={"25"} data-testid={"delete"} color={color} />;
    case "basket":
      return <IconBasket size={"25"} data-testid={"delete"} color={color} />;
    case "device":
      return (
        <IconDeviceDesktop size={"25"} data-testid={"delete"} color={color} />
      );
    case "ip-address":
      return <IconLocationPin size={"25"} data-testid={"delete"} />;
    case "clock-question-small":
      return (
        <IconClockQuestion size={"20"} data-testid={"question"} color={color} />
      );
    case "question":
      return <IconHelpCircleFilled size={SIZE} color={color} />;
    case "video-small":
      return (
        <IconBrandYoutubeFilled
          size={"20"}
          data-testid={"video"}
          color={color}
        />
      );
    case "video-small-2":
      return (
        <IconBrandYoutube size={"20"} data-testid={"vide-2"} color={color} />
      );
    case "list":
      return <IconList size={"20"} data-testid={"list"} color={color} />;
    case "layout-grid":
      return (
        <IconLayoutGrid size={"20"} data-testid={"layout grid"} color={color} />
      );
    case "book-off":
      return <IconBookOff size={SIZE} data-testid={"book off"} color={color} />;
    case "wand":
      return <IconWand size={SIZE} data-testid={"wand"} color={color} />;
    case "sandbox":
      return <IconSandbox size={SIZE} data-testid={"sandbox"} color={color} />;
    case "search":
      return <IconSearch size={SIZE} data-testid={"search"} color={color} />;
    case "school":
      return <IconSchool size={SIZE} data-testid={"school"} color={color} />;
    case "check-circle":
      return (
        <IconCircleCheckFilled
          size={SIZE}
          color={color}
          data-testid={"check circle"}
        />
      );
    case "check-circle-no-fill":
      return (
        <IconCircleCheck
          size={SIZE}
          color={color}
          data-testid={"check circle"}
        />
      );
      case "auto-play":
      return (
        <IconRepeat size={SIZE} color={color} data-testid={"auto-play"} />
      );
      case "mute":
      return (
        <IconRepeatOff size={SIZE} color={color} data-testid={"mute"} />
      );
    case "x-circle":
      return (
        <IconCircleXFilled color={color} size={SIZE} data-testid={"x circle"} />
      );
    case "x-circle-no-fill":
      return <IconCircleX color={color} size={SIZE} data-testid={"x circle"} />;
    case "arrow-left":
      return (
        <IconArrowLeft size={SIZE} data-testid={"arrow left"} color={color} />
      );
    case "user-cancel":
      return (
        <IconUserCancel size={SIZE} data-testid={"user cancel"} color={color} />
      );
    case "link-off":
      return <IconLinkOff size={SIZE} data-testid={"link off"} color={color} />;
    case "open-url":
      return (
        <IconExternalLink size={SIZE} data-testid={"open url"} color={color} />
      );
    case "url":
      return (
        <IconLinkPlus size={SIZE} data-testid={"open url"} color={color} />
      );
    case "briefcase":
      return (
        <IconBriefcase size={SIZE} data-testid={"briefcase"} color={color} />
      );
    case "arrow-up":
      return (
        <IconChevronUp size={SIZE} data-testid={"briefcase"} color={color} />
      );
    case "arrow-down2":
      return (
        <IconChevronDown size={SIZE} data-testid={"briefcase"} color={color} />
      );
    case "pig-money":
      return (
        <IconPigMoney size={SIZE} data-testid={"briefcase"} color={color} />
      );
    case "door-exit":
      return <IconDoorExit size={SIZE} data-testid="door-exit" color={color} />;
    case "book-shelf":
      return <IconBooks size={SIZE} data-testid="door-exit" color={color} />;
    case "usb":
      return <IconDeviceUsb size={SIZE} color={color} />;
    case "key":
      return <IconKey size={SIZE} color={color} />;
    case "totp":
      return <IconPasswordMobilePhone size={SIZE} color={color} />;
    case "sms":
      return <IconDeviceMobileMessage size={SIZE} color={color} />;
    case "user-up":
      return <IconUserStar size={SIZE} color={color} />;
    case "Share":
      return <IconShare size={SIZE} color={color} />;
    case "Comment":
      return <IconMessage size={SIZE} color={color} />;
    case "Like":
      return <IconThumbUp size={SIZE} color={color} />;
    case "touchpoint":
      return <IconHandClick size={SIZE} color={color} />;
    case "copy":
      return <IconCopy size={SIZE} color={color} />;
    case "robot":
      return <IconRobot size={SIZE} color={color} />;
    case "goal":
      return <IconTargetArrow size={SIZE} color={color}/>;
    case "target":
      return <IconTarget size={SIZE} color={color}/>;
    case "lightbulb":
      return <IconBulb size={SIZE} color={color}/>;
    case "globe":
      return <IconGlobe size={SIZE} color={color}/>;
    case "chart-line":
      return <IconTrendingUp size={SIZE} color={color}/>;
    case "shield":
      return <IconShield size={SIZE} color={color}/>;
    case "briefcase":
      return <IconBriefcase size={SIZE} color={color}/>;
    case "bullhorn":
      return <IconMail size={SIZE} color={color}/>;
    case "code":
      return <IconCode size={SIZE} color={color}/>;
    case "calculator":
      return <IconCalculator size={SIZE} color={color}/>;
    case "trending-up":
      return <IconTrendingUp size={SIZE} color={color}/>;
    case "user-check":
      return <IconUserCheck size={SIZE} color={color}/>;
    case "megaphone":
      return <IconSpeakerphone size={SIZE} color={color}/>;
    case "palette":
      return <IconPalette size={SIZE} color={color}/>;
    case "smile":
      return <IconMoodSmile size={SIZE} color={color}/>;
    case "resize":
      return <IconResize size={SIZE} color={color}/>;
    case "linkedin":
      return <IconBrandLinkedin size={SIZE} color={color}/>;
    case "wait":
      return <IconActivity size={SIZE} color={color}/>;
    case "continue":
      return <IconRepeat size={SIZE} color={color}/>;
    case "support":
      return <IconHelpCircle size={SIZE} color={color}/>;
    case "business":
      return <IconBuildingBank size={SIZE} color={color}/>;
    case "workforce":
      return <IconUserCheck size={SIZE} color={color}/>;
  }
}
